// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-page {
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}


.date-display {
  font-size: 1.5rem;
  color: #495057;
  font-weight: 500;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #343a40;
  margin-bottom: 10px;
}

.title-underline {
  height: 4px;
  width: 100px;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  margin: 0 auto;
  border-radius: 2px;
}

.menu-container {
  padding: 40px 0;
}

.menu-card {
  border: none;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.menu-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.meal-image-container {
  position: relative;
  overflow: hidden;
}

.meal-image {
  height: 200px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.menu-card:hover .meal-image {
  transform: scale(1.05);
}

.meal-time-badge {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.meal-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #343a40;
  margin-bottom: 15px;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #f8f9fa;
}

.menu-details {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 10px;
}

.menu-details-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
}

.menu-description {
  white-space: pre-line;
  color: #6c757d;
}

.menu-date {
  margin-top: 10px;
  text-align: right;
}

.footer {
  background-color: #343a40;
  color: #ffffff;
  padding: 20px 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .main-title {
    font-size: 2rem;
  }

  .logos {
    display: none!important;
  }
  .tituloalmuerzo{
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .date-display {
    font-size: 1.2rem;
    margin-top: 15px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/MenuHoyPage.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;AACpC;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css\");\n\n.menu-page {\n  background-color: #f8f9fa;\n  min-height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n}\n\n\n.date-display {\n  font-size: 1.5rem;\n  color: #495057;\n  font-weight: 500;\n}\n\n.main-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #343a40;\n  margin-bottom: 10px;\n}\n\n.title-underline {\n  height: 4px;\n  width: 100px;\n  background: linear-gradient(90deg, #ff7e5f, #feb47b);\n  margin: 0 auto;\n  border-radius: 2px;\n}\n\n.menu-container {\n  padding: 40px 0;\n}\n\n.menu-card {\n  border: none;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.menu-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n}\n\n.meal-image-container {\n  position: relative;\n  overflow: hidden;\n}\n\n.meal-image {\n  height: 200px;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.menu-card:hover .meal-image {\n  transform: scale(1.05);\n}\n\n.meal-time-badge {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n}\n\n.meal-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #343a40;\n  margin-bottom: 15px;\n  text-align: center;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #f8f9fa;\n}\n\n.menu-details {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 10px;\n}\n\n.menu-details-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 10px;\n}\n\n.menu-description {\n  white-space: pre-line;\n  color: #6c757d;\n}\n\n.menu-date {\n  margin-top: 10px;\n  text-align: right;\n}\n\n.footer {\n  background-color: #343a40;\n  color: #ffffff;\n  padding: 20px 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .main-title {\n    font-size: 2rem;\n  }\n\n  .logos {\n    display: none!important;\n  }\n  .tituloalmuerzo{\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .date-display {\n    font-size: 1.2rem;\n    margin-top: 15px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
